import { IFormFieldSubmission } from "@common/redux/formSubmission/interface";
import { FieldProps } from "../FormFieldSelector/interfaces";
import {
  IFormYearDropdownFieldConfigurationClient,
  IFormYearDropdownFieldConfigurationServer,
} from "./interface";

export const transformFormYearDropdownFieldConfigClientToServer = (
  fieldConfigClient: IFormYearDropdownFieldConfigurationClient
): IFormYearDropdownFieldConfigurationServer => {
  const {
    placeholder,
    initialValue,
    noOfVisibleYears,
    initialValueYear,
    initialValueYearType,
    defaultYearVisible,
    isMultipleSelection,
    writeJavascript,
    noOfHidingYearsFromCurrentYear,
  } = fieldConfigClient;
  const fieldConfigServer = {
    placeHolder: placeholder,
    initialValue: initialValue,
    noOfVisibleYears: noOfVisibleYears,
    initialValueYear: initialValueYear,
    initialValueYearType: initialValueYearType,
    noOfHidingYearsFromCurrentYear: noOfHidingYearsFromCurrentYear,
    defaultYearVisible: defaultYearVisible,
    writeJavascript: writeJavascript,
    isMultipleSelection: isMultipleSelection,
  };
  return fieldConfigServer;
};

export const transformFormYearDropdownFieldConfigServerToClient = (
  fieldConfigServer: IFormYearDropdownFieldConfigurationServer
): IFormYearDropdownFieldConfigurationClient => {
  const {
    placeHolder,
    initialValue,
    noOfVisibleYears,
    initialValueYear,
    initialValueYearType,
    defaultYearVisible,
    isMultipleSelection,
    writeJavascript,
    noOfHidingYearsFromCurrentYear,
  } = fieldConfigServer;
  const fieldConfigClient = {
    placeholder: placeHolder,
    initialValue: initialValue,
    noOfVisibleYears: noOfVisibleYears,
    initialValueYear: initialValueYear,
    initialValueYearType: initialValueYearType,
    defaultYearVisible: defaultYearVisible,
    isMultipleSelection: isMultipleSelection,
    writeJavascript: writeJavascript,
    noOfHidingYearsFromCurrentYear: noOfHidingYearsFromCurrentYear,
  };
  return fieldConfigClient;
};

export const generateYearOptions = (
  numYears: string,
  year: string,
  noOfHidingYearsFromCurrentYear?: string
) => {
  const baseYear = year ? Number(year) : new Date().getFullYear();
  const options = [];
  const updatedYear = Number(numYears);
  const yearsToHide = Number(noOfHidingYearsFromCurrentYear) || 0;

  for (let i = yearsToHide; i < updatedYear + yearsToHide; i++) {
    const startYear = baseYear - i;
    const endYear = startYear + 1;
    const yearLabel = `${startYear}-${String(endYear).slice(2)}`;
    options.push({ value: yearLabel, content: yearLabel });
  }
  return options;
};
export const getFinancialYear = (
  previousYearCount?: number,
  initialValueType?: yearSelectorInitialValueTypes
) => {
  const today = new Date();
  let startYear = today.getFullYear();

  if (
    previousYearCount &&
    initialValueType === yearSelectorInitialValueTypes.previousYear
  ) {
    startYear -= previousYearCount;
  }

  const endYear = startYear + 1;
  return `${startYear}-${String(endYear).slice(-2)}`;
};

export enum yearSelectorInitialValueTypes {
  currentYear = "currentYear",
  custom = "custom",
  previousYear = "previousYear",
}

export const validateYearSelectorFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission
): [boolean, string] => {
  const { isRequired, isVisible } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;
  const submissionValue =
    (fieldSubmissionValue && fieldSubmissionValue?.selectedOptions) || [];
  if (isRequired && !!isVisible && !submissionValue.length) {
    return [false, "This is a Required Field"];
  }
  return [true, ""];
};
